<template lang="pug">
fullscreen(:fullscreen.sync="Store.fullscreen").app
  menu-style-black
    window-style-black
      transition(name="fade", mode="out-in")
        keep-alive
          router-view.root
  transition(name="fade")
    .progresses(v-if="Store.progresses.length > 0")
      Progress(v-for="progress in Store.progresses", :key="Id(progress)", :label="progress.label")
</template>


<script lang="ts">
import Vue from 'vue'
import Fullscreen from "@/components/Fullscreen/index.vue";
import Progress from "./Progress.vue";

export default Vue.extend({
  components: { Fullscreen, Progress },
})
</script>



<style lang="scss" scoped>
.app {
  height: 100%;
  background-color: #333;
}

.root {
  height: 100%;
}

.progresses {
  border-radius: 8pt 0 0 0;
  padding: 0.5em;
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 999;
  background-color: rgba(31, 31, 31, 0.75);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
